import { HttpError } from "@refinedev/core";
import axios from "axios";

const axiosInstance = axios.create();

axios.defaults.withCredentials = true;

axiosInstance.interceptors.request.use((request) => {
  // Retrieve the token from local storage

  const token = localStorage.getItem("auth");

  if (token) {
    // Check if the header property exists
    if (request.headers) {
      // Set the Authorization header if it exists
      request.headers["Authorization"] = `Bearer ${token}`;
    }
  }

  return request;
});

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const customError: HttpError = {
      ...error,
      errors: error.response?.data?.errors,
      message: error.response?.data?.message,
      statusCode: error.response?.status,
    };

    return Promise.reject(customError);
  }
);

export { axiosInstance };
